import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getSecuEarningQualityThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_EARNINGS_QUALITY',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getEarningsQuality(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadSecuEarningQuality = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_EARNINGS_QUALITY',
  async (data) => {
    const response = await FinancialAnalysisService.downloadEarningsQuality(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
